<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Inventory Summary Reports
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>

                                    <v-col md="4" cols="12">
                                        <div class="d-flex align-center flex-column">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                        >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="success"
                                            @click="exportToCSV"
                                            >CSV</v-btn
                                            >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="primary"
                                            @click="exportToExcel"
                                            >EXCEL</v-btn
                                            >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="red"
                                            @click="exportToPDF"
                                            >PDF</v-btn
                                            >
                                        </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col
                                        md="4"
                                        cols="12"
                                        class="d-flex justify-end pr-5"
                                    >
                                        <v-btn
                                            prepend-icon="mdi-restart"
                                            variant="flat"
                                            color="indigo"
                                            @click="submit"
                                            :loading="loading"
                                        >
                                            Generate Report
                                        </v-btn>
                                    </v-col>

                                </v-row>

                                <v-data-table
                                :headers="headers"
                                :items="reports.product_stock"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                >
                                    <template v-slot:item.index="{ index}">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.valuation="{ item }">
                                        {{ item.valuation }}
                                    </template>

                                    <!-- Footer with totals -->
                                    <template v-slot:bottom>
                                        <div class="v-data-table-footer">
                                            <v-row class="align-center">
                                                <v-col cols="12" class="text-right">
                                                    <strong>Totals:</strong> 
                                                    <span class="ml-4">Quantity: <strong class="text-blue-darken-2">{{ reports.total_quantity }}</strong></span>
                                                    <span class="ml-4">Valuation: <strong class="text-green-darken-2">{{ reports.total_valuation }}</strong></span>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
    components: {},
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        search: "",
        dialog: false,
        data: {},
        headers: [
            { title: "#SL", align: "center", key: "index", sortable: false,},
            { title: "Warehouse", key: "warehouse_name", align: "left", sortable: false },
            { title: "Product Name", key: "product_name", align: "left", sortable: false },
            { title: "Unit Price", key: "purchase_unit_price", align: "left", sortable: false },
            { title: "Quantity", key: "quantity", align: "center", sortable: false },
            { title: "Valuation", key: "valuation", align: "center", sortable: false,  },     
        ],
    }),
    watch: {},
    created() {

        const promises = [];

        if (this.$store.getters.getProductTypeList.length == 0) {
            promises.push(this.$store.dispatch("getProductTypeList"));
        }
        if (this.$store.getters.getCategoryList.length == 0) {
            promises.push(this.$store.dispatch("getCategoryList"));
        }
        if (this.$store.getters.getSubCategoryList.length == 0) {
            promises.push(this.$store.dispatch("getSubCategoryList"));
        }
        if (this.$store.getters.getBrandList.length == 0) {
            promises.push(this.$store.dispatch("getBrandList"));
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getSupplierMapList;
        },
        getProductTypeList() {
            let data = this.$store.getters.getProductTypeList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        getCategoryList() {
            let data = this.$store.getters.getCategoryList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        
        getSubCategoryList() {
            let data = this.$store.getters.getSubCategoryList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        getBrandList() {
            let data = this.$store.getters.getBrandList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add validation if needed
                // product_type: yup.number().positive().integer().nullable().label('Product Type'),
                // category: yup.number().positive().integer().nullable().label('Category'),
                // subcategory: yup.number().positive().integer().nullable().label('Sub Category'),
            }),
        });

        const product_type = useField("product_type");
        const category = useField("category");
        const subcategory = useField("subcategory");
        const brand = useField("brand");
        const errorMessages = ref("");
        const loading = ref(false);
        const store = useStore();
        const reports = ref([]);

        // Computed properties for totals
        const totalQuantity = computed(() => {
            if (!reports.value.product_stock || reports.value.product_stock.length === 0) {
                return 0;
            }
            return reports.value.product_stock.reduce((sum, item) => {
                return sum + (parseFloat(item.quantity) || 0);
            }, 0);
        });

        const totalValuation = computed(() => {
            if (!reports.value.product_stock || reports.value.product_stock.length === 0) {
                return 0;
            }
            return reports.value.product_stock.reduce((sum, item) => {
                return sum + (parseFloat(item.valuation) || 0);
            }, 0);
        });

        const submit = handleSubmit((values) => {
        loading.value = true;

        Axios.get(`${prefix}inventory/inventory-summary`, { params: values })
            .then((response) => {
                reports.value = response.data.data;
                console.log(reports.value.product_stock);
                loading.value = false;
            })
            .catch((error) => {
                loading.value = false;
                toast.error(error.response.data.message);
            });
        });

        return {
            product_type,
            category,
            subcategory,
            brand,
            submit,
            errorMessages,
            loading,
            reports,
            totalQuantity,
            totalValuation,
        };
    },
    methods: {
        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },
        editItem(item) {
            this.$store.commit("setEditingProduct", item);
            this.$router.push({ name: "add-product", query: {id: item.id} });
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = [
                "#SL",
                "Warehouse",
                "Product Code",
                "Product Name",
                "Batch",
                "Unit Price",
                "Quantity",
                "Valuation",
            ];
            const rows = (this.reports.product_stock || []).map((item) => [
                serialNumber++,
                item.warehouse_name,
                item.product_code,
                item.product_name,
                item.batch_no,
                item.purchase_unit_price,
                item.quantity,
                item.valuation,
            ]);
            
            // Add totals row
            rows.push([
                "",
                "",
                "",
                "",
                "",
                "TOTAL:",
                this.totalQuantity.toLocaleString(),
                this.totalValuation.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}),
            ]);
            
            this.$exportTableToPDF(
                columns,
                rows,
                "Inventory Summary Report",
                "inventory_summary_report_" + this.$fileDate()
            );
        },
        exportToExcel() {
            var data = [[
                "#SL",
                "Warehouse",
                "Product Code",
                "Product Name",
                "Batch",
                "Unit Price",
                "Quantity",
                "Valuation",
            ]];
            var serialNumber = 1;
            (this.reports.product_stock || []).forEach((item) => {
                data.push([
                serialNumber++,
                item.warehouse_name,
                item.product_code,
                item.product_name,
                item.batch_no,
                item.purchase_unit_price,
                item.quantity,
                item.valuation,
                ]);
            });
            
            // Add totals row
            data.push([
                "",
                "",
                "",
                "",
                "",
                "TOTAL:",
                this.totalQuantity,
                this.totalValuation,
            ]);
            
            this.$exportTableToExcel(data, "inventory_summary_report_" + this.$fileDate());
        },
        exportToCSV() {
            var data = [[
                "#SL",
                "Warehouse",
                "Product Code",
                "Product Name",
                "Batch",
                "Unit Price",
                "Quantity",
                "Valuation",
            ]];
            var serialNumber = 1;
            (this.reports.product_stock || []).forEach((item) => {
                data.push([
                serialNumber++,
                item.warehouse_name,
                item.product_code,
                item.product_name,
                item.batch_no,
                item.purchase_unit_price,
                item.quantity,
                item.valuation,
                ]);
            });

            // Add totals row
            data.push([
                "",
                "",
                "",
                "",
                "",
                "TOTAL:",
                this.totalQuantity,
                this.totalValuation,
            ]);

            this.$exportTableToCSV(data, "inventory_summary_report_" + this.$fileDate());
        },
    },
    mounted() {
        // Auto-trigger search on mount like the requisition list
        this.$nextTick(() => {
            this.$refs.searchButton.$el.click();
        });   
    },
};
</script>